namespace SPA {
	export namespace Realtor2 {
		export class NewObject extends ui.tab.TabHTMLPresentation {

			private m_Guide: SPA.Guide.GuideRoot;
			private m_Data: INewDisposalObject;

			private m_Order: IOrder;
			private Mode: 'view' | 'new';

			public constructor(private m_Company: Wollmilch.CompanyObject, object: any = null) {
				super();

				this.m_Guide = new SPA.Guide.GuideRoot();
				this.Mode = object !== null ? 'view' : 'new';
				// Todo - detect new / edit mode
				this.Mode = 'new';
				this.m_Data =
					{
						object:
							{
								project: 'disposal',
								address:
									{
										street: '',
										housenumber: '',
										postalcode: '',
										city: '',
										state: '',
										country: 'DE',
										ags: ''
									},
								quality:
									{
										micro: -1,
										macro: -1,
										annotation: ''
									},
								seller:
									{
										id: null
									},
								owner:
									{
										id: null
									}
							},
						property:
							{
								area:
									{
										building: null,
										garden: null
									},
								leasehold:
									{
										present: false,
										residual_time: 0,
										ground_rent: 0,
										compensation: 0,
										disadvantage: 0,
										rate: 0,
										annotation: ''
									},
								structural:
									{
										path: null,
										layout:
											{
												value: null,
												corner: false,
												pipe: false,
												slope: false,
												towel: false
											},
										garden: null,
										courtyard: null,
										enclosure: null,
										annotation: ''
									},
								register:
									{
										registry_deeds: '',
										court: '',
										volume: '',
										page: '',
										list: [],
										active_annotation: '',
										annotation: ''
									},
								easements: {
									value: 'NOTHING',
									annotation: ''
								},
								preload: [],
								annotation: ''
							},
						common:
							{
								type: null,
								heating:
									{
										type:
											{
												central: false,
												per_floor: false,
												per_unit: false
											},
										features:
											{
												gas: false,
												oil: false,
												electricity: false,
												pellet: false,
												plant_oil: false,
												geothermal_pump: false,
												air_heat_exchanger: false,
												coal: false,
												biomass: false,
												radiation: false,
												solar: false,
												district: false,
												log_man: false,
												log_auto: false,
												floor_heating: false,
												heater: false
											}
									},
								annotation: ''
							},
						details:
							{
								object:
									{
										construction_year: null,
										lettability: 'SATISFYING',
										usability: 'SATISFYING',
										use_capability: true,
										annotation: ''
									},
								living_area:
									{
										type: 'NGF',
										value: null
									},
								outdoor_facilities:
									{
										type: 'RELATIVE',
										value: 5
									},
								parking: []
							},
						modernization:
							{
								object_condition:
									{
										value: 'SATISFYING',
										annotation: ''
									},
								redevelopment:
									{
										redeveloped: false,
										windows:
											{
												value: null,
												year: null
											},
										electricity:
											{
												value: null,
												year: null
											},
										gas:
											{
												value: null,
												year: null
											},
										water:
											{
												value: null,
												year: null
											},
										sewage:
											{
												value: null,
												year: null
											},
										heating_system:
											{
												value: null,
												year: null
											},
										sanitary:
											{
												value: null,
												year: null
											},
										interior:
											{
												value: null,
												year: null
											},
										roof:
											{
												value: 0,
												year: null
											},
										outdoor_walls:
											{
												value: 0,
												year: null
											},
										floor_plan:
											{
												value: 0,
												year: null
											},
										annotation: ''
									},
								additional:
									{
										value_depressing:
											{
												flaws: null,
												maintenance_backlog: null,
												other: null,
												annotation: ''
											},
										value_improving:
											{
												value: null,
												annotation: ''
											}
									},
								annotation: ''
							},
						benefits: {},
						general:
							{
								price:
									{
										value: null,
										currency: 'EUR'
									},
								yearlyRent:
									{
										value: null,
										currency: 'EUR'
									},
								fee:
									{
										interior: null,
										exterior: null
									},
								order_until:
									{
										value: null,
										format: 'd.m.Y'
									},
								title: '',
								annotation: '',
								ref: ''
							}
					};

				if (object !== null) {
					const newData = deepmerge(this.m_Data, object, {});
					this.m_Data = newData;
				}

				this.m_Order =
					{
						lrm: false,
						register:
							{
								order: false,
								file: null
							},
						easement:
							{
								order: false,
								file: null
							},
						datapackage: false,
						assessment:
							{
								immowertv: true,
								belwertv: true,
								belwertv_bafin: true
							}
					};

				this.buildGuide();
			}

			public setLRM(lrm: boolean): void {
				this.m_Order.lrm = lrm;
			}

			public setDataPackage(dp: boolean): void {
				this.m_Order.datapackage = dp;
			}

			public setRegister(register: IOrderWithFile): void {
				this.m_Order.register = register;
			}

			public setEasement(easement: IOrderWithFile): void {
				this.m_Order.easement = easement;
			}

			public getLRM(): boolean {
				return this.m_Order.lrm;
			}

			public getDataPackage(): boolean {
				return this.m_Order.datapackage;
			}

			public getRegister(): IOrderWithFile {
				return this.m_Order.register;
			}

			public getEasement(): IOrderWithFile {
				return this.m_Order.easement;
			}

			public sendForm(): void {
				new Wollmilch.AJAX(
					{
						method: 'POST',
						url: 'object/new',
						data: Object.assign(
							{
								orders: this.m_Order
							},
							this.m_Data
						),
						on:
							{
								success: (text: string) => {
									const _json = Wollmilch.jsonize(text);

									if (_json === null || !_json.success) {
										app.addNotify(
											{
												body: [
													'Das Anlegen des Objektes ist fehlgeschlagen.'
												],
												context: 'danger',
												title: ['Anlegen fehlgeschlagen'],
												timeout: Number(app.getConfigValue("ToastTimeout"))
											}
										);

										return;
									}

									app.addNotify(
										{
											body: ['Das Objekt wurde erfolgreich angelegt.'],
											context: 'success',
											title: ['Erfolg'],
											timeout: Number(app.getConfigValue("ToastTimeout"))
										}
									);

									app.getGlobalTabControl().addTab(
										_json.data.ObjectNumber,
										new Realtor.Page(_json.data),
										true,
										true,
										false
									);

									app.getGlobalTabControl().removeTab(this.m_Entry);

									return;
								}
							}
					},
					Wollmilch.AJAXCallbase_e.REALTOR
				).send();
			}

			public checkForm(_form: ui.Form.Form, _timeout: number = 5000): boolean {
				if (_form.isValid({}, [])) {
					return true;
				}

				app.addNotify(
					{
						title: ['Formularangaben unvollständig/inkorrekt'],
						body: ['Bitte überprüfen Sie Ihre Formularangaben und korrigieren/vervollständigen Sie diese bitte.'],
						context: 'warning',
						timeout: _timeout
					}
				);

				return false;
			}

			public rebuild(root: ui.base.BaseHTMLElement|JQuery): NewObject {
				this.empty();
				this.remove();

				this.appendTo(new ui.Box.Box().appendTo(root));

				this.m_Guide.rebuild(this);

				return this;
			}

			private buildGuide(): void {
				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: '1',
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Allg. Angaben'
						},
						new New.Common(this.m_Company, this.m_Data.object, this),
						false
					)
				);

				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: '2',
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Grundstück'
						},
						new New.Property(this.m_Data, this),
						false
					)
				);

				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: '3',
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Objektart'
						},
						new New.ObjectCommon(this.m_Data.common, this),
						false
					)
				);

				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: '4',
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Objektdetails'
						},
						new New.ObjectDetails(this.m_Data.details, this),
						false
					)
				);

				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: '5',
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Modernisierung'
						},
						new New.Modernization(this.m_Data.modernization, this),
						false
					)
				);
				/*
								this.m_Guide.addItem(
									new SPA.Guide.GuideItem(
										{
											label: '6',
											border: {
												color: '#535353',
												radius: '50%',
												style: 'solid',
												width: '2px'
											},
											description: 'Erträge'
										},
										new New.Benefit(),
										false,
										this
									)
								);
				*/
				this.m_Guide.addItem(
					new SPA.Guide.GuideItem(
						{
							label: '6',
							border: {
								color: '#535353',
								radius: '50%',
								style: 'solid',
								width: '2px'
							},
							description: 'Abschluss'
						},
						new New.Final(this.m_Data.general, this.m_Company, this),
						false
					)
				);
			}

		}
	}
}
